import React, { Component } from "react";
import { connect } from "react-redux";

import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

class TimeoutTimer extends Component {
  _isMounted = false;
  timer;
  state = {
    Timer: this.props.session_timeout_duration * 60,
    CircleColour: "green",
    isIdle: false,
  };
  setStateWithCheckMount = (payload) => {
    if (this._isMounted) {
      this.setState(payload);
    }
  };

  componentDidMount() {
    const { session_timeout_duration } = this.props;
    let sessionElapsed;
    let CircleColourHelper;
    this._isMounted = true;
    localStorage.setItem("lastActiveTime", Date.now());
    document.addEventListener("mousedown", this.doAction);
    document.addEventListener("mouseenter", this.doAction);
    document.addEventListener("keypress", this.doAction);

    this.timer = setInterval(() => {
      sessionElapsed =
        Date.now() - parseFloat(localStorage.getItem("lastActiveTime"));
      if (session_timeout_duration * 60 - sessionElapsed / 1000 < 60) {
        CircleColourHelper = "green";
        if (session_timeout_duration * 60 - sessionElapsed / 1000 < 41) {
          CircleColourHelper = "amber";
        }
        if (session_timeout_duration * 60 - sessionElapsed / 1000 < 21) {
          CircleColourHelper = "red";
        }
        if (session_timeout_duration * 60 - sessionElapsed / 1000 < 1) {
          this.props.logout();
        }

        this.setStateWithCheckMount({
          isIdle: true,
          Timer: Math.floor(
            session_timeout_duration * 60 - sessionElapsed / 1000
          ),
          CircleColour: CircleColourHelper,
        });
      }
    }, 1000);
  }

  doAction = (event) => {
    if (!this.state.isIdle) {
      localStorage.setItem("lastActiveTime", Date.now());
    }
  };
  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener("mousedown", this.doAction);
    document.removeEventListener("mouseenter", this.doAction);
    document.removeEventListener("keypress", this.doAction);

    clearInterval(this.timer);
  }

  clearTimer = () => {
    this.setStateWithCheckMount({
      isIdle: false,
      Timer: 59,
      CircleColour: "green",
    });
    localStorage.setItem("lastActiveTime", Date.now());
  };
  render() {
    return this.state.isIdle ? (
      <div className="timeout-timer-wrapper">
        <div className="timeout-timer">
          <button className="btn btn-close" onClick={this.clearTimer}>
            <i className="icon-omni-close-circle" />
          </button>
          <p>Your session is about to expire</p>
          <div className={"circle " + this.state.CircleColour}>
            <CircularProgressbarWithChildren
              value={(this.state.Timer / 60) * 100}
              strokeWidth={2}
            >
              <h1>{this.state.Timer}</h1>
              <span>Seconds</span>
            </CircularProgressbarWithChildren>
          </div>
          <button className="btn btn-continue" onClick={this.clearTimer}>
            Continue using {this.props.siteName}
          </button>
        </div>
      </div>
    ) : (
      ""
    );
  }
}
export default connect((state) => state.User)(TimeoutTimer);
